import React, { useCallback, useEffect } from 'react';

import { toRelativeUrl } from '@okta/okta-auth-js';
import { Security } from '@okta/okta-react';
import { useHistory } from 'react-router-dom';

import { oktaAuth } from './okta';

export const GGSecurity = ({ children }: any) => {
  const history = useHistory();
  const restoreOriginalUri = useCallback(
    async (_oktaAuth: any, originalUri: any) => {
      history.replace(
        toRelativeUrl(originalUri || '/', window.location.origin)
      );
    },
    [history]
  );

  useEffect(() => {
    const onVisibilityChange = (_: any) => {
      const isLoginPage = window.location.pathname === '/login';
      const isCallbackPage = window.location.pathname === '/callback';
      const isOpenBrowserTab = document.visibilityState === 'visible';

      if (isOpenBrowserTab && !isLoginPage && !isCallbackPage) {
        oktaAuth.authStateManager
          .updateAuthState()
          .then(({ isAuthenticated }: any) => {
            if (!isAuthenticated) {
              window.location.reload();
            }
          });
      }
    };
    document.addEventListener('visibilitychange', onVisibilityChange, {
      capture: true,
    });
    return () => {
      document.removeEventListener('visibilitychange', onVisibilityChange, {
        capture: true,
      });
    };
  }, [oktaAuth]);

  const handleAuthRequired = async () => {
    const previousAuthState = oktaAuth.authStateManager.getPreviousAuthState();
    if (
      !previousAuthState?.isAuthenticated &&
      history.location.pathname !== '/login'
    ) {
      history.push('/login');
    }
  };

  return (
    <Security
      oktaAuth={oktaAuth}
      onAuthRequired={handleAuthRequired}
      restoreOriginalUri={restoreOriginalUri}
    >
      {children}
    </Security>
  );
};
export default GGSecurity;
